/*! @hebcal/core v5.9.8, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */
import './locale.js';
import { Locale } from '@hebcal/hdate';

/** @private */
function renderParshaName(parsha, locale) {
    const locale0 = locale !== null && locale !== void 0 ? locale : Locale.getLocaleName();
    let name = Locale.gettext(parsha[0], locale0);
    if (parsha.length === 2) {
        const hyphen = locale0 === 'he' ? '־' : '-';
        name += hyphen + Locale.gettext(parsha[1], locale0);
    }
    name = name.replace(/'/g, '’');
    const str = Locale.gettext('Parashat', locale) + ' ' + name;
    return str.normalize();
}

export { renderParshaName };
//# sourceMappingURL=parshaName.js.map
